import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import _ from "lodash";
import ApiWallet from "../../../../core/api/api.wallet";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SwalMessage from "../../_Components/SwalMessage";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import SplitNumber from "../../_Components/SplitNumber";
import ApiAccount from "../../../../core/api/api.account";
import AgentWithdrawal from "../../../../core/api/api.agentWithdrawal";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import { Alert } from "@mui/material";

export const NewWithdrawalsModal = ({
  showModalWithdrawals,
  setShowModalWithdrawals,
  selectedWithdraw,
}) => {
  let handleClose = (e) => {
    setShowModalWithdrawals(false);
  };
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm({
    defaultValues: {
      minimumDate: {},
      maximumDate: {},
      promoCodeId: 0,
    },
  });
  const [riallBalance, setRiallBalance] = useState(0);
  const [accounts, setAccounts] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  const dataForm = {
    rialAmount: register("rialAmount", { required: true }),
    accountId: register("accountId", { required: true }),
  };

  useEffect(() => {
    (async () => {
      try {
        setLoadingData(true);
        const resultApiWallet = await ApiWallet.getAgentWalletByUserId();
        setRiallBalance(resultApiWallet?.data?.riallBalance);
        let restAccount = ApiAccount.getAllAccountForUserId().then((rest) => {
          if (!_.isEmpty(rest) && !_.isEmpty(rest.data)) {
            setAccounts(rest.data);
          }
        });
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
        setLoadingData(false);
      }
    })();
  }, [refresh]);

  const onSubmit = async (data) => {
    try {
      data.rialAmount = data.rialAmount.split(" ").join("").split(",").join("");
      if (parseInt(data.rialAmount) > riallBalance) {
        SwalMessage({
          title: "مبلغ وارد شده بیشتر از موجودی کیف پول شماست",
          iSsuccess: false,
          timer: 5000,
        });

        return;
      } else {
        const response = await AgentWithdrawal.createUserWithdrawal({
          rialAmount: parseInt(data.rialAmount),
          destinationAccountId: parseInt(data.accountId),
        });
        if (!_.isEmpty(response) && response.data != undefined) {
          SwalMessage({
            title: response.message,
            iSsuccess: response.data,
            timer: 5000,
          });
          handleClose();
        }
        if (response.succeeded) {
          document.getElementById("submitButton").click();
        }
      }
    } catch (error) {
      console.log("error=", error);
    }
  };

  return (
    <div>
      <Modal
        centered
        size="md"
        show={showModalWithdrawals}
        onHide={handleClose}
      >
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>درخواست برداشت وجه</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loadingData ? (
              "در حال دریافت اطلاعات"
            ) : (
              <>
                <Col xs={12} className="text-center px-0">
                  <div className=" d-flex justify-content-between px-2 border-bottom pb-5 mb-5">
                    <div> موجودی کیف پول </div>
                    <div>
                      <span className="text-dark font-weight-bold">
                        <SplitNumber number={riallBalance} />
                      </span>{" "}
                      تومان
                    </div>
                  </div>
                </Col>
                <div>
                  {accounts != null && accounts.length > 0 ? (
                    <>
                      <div className=" pb-4 text-justify text-center">
                        جهت برداشت از کیف پول، مبلغ موردنظر را وارد نمایید.
                      </div>

                      <div className="d-flex align-items-center justify-content-between">
                        <Form.Select
                          {...register("accountId", {
                            required: "لطفا یکی از کارت ها را انتخاب نمایید",
                          })}
                          as="select"
                          name="accountId"
                          className="rounded-2 d-inline-block text-center fs-normal rounded-start-0"
                          style={{ height: "38px" }}
                        >
                          <option value=""> انتخاب شماره کارت </option>
                          {accounts.map((item, index) => (
                            <option value={item.value} key={`opt_${index}`}>
                              {item.title}
                            </option>
                          ))}
                        </Form.Select>
                        <Link
                          className="btn btn-primary d-inline-block rounded-end-0"
                          to="/agentAccount"
                        >
                          <AddCircle className="mr-1" />
                        </Link>
                      </div>
                      {errors.accountId && (
                        <span className="text-danger">
                          لطفا یکی از کارت ها را انتخاب نمایید
                        </span>
                      )}
                    </>
                  ) : (
                    (accounts == null || accounts.length == 0) && (
                      <>
                        {/* اگر تا حالا شماره کارت وارد نکرده بود */}
                        <Alert severity="warning" className="rounded-3">
                          شما تا کنون شماره حساب ثبت نکرده اید. جهت برداشت از
                          کیف پول، ابتدا شماره حساب خود را اضافه کنید.
                        </Alert>
                      </>
                    )
                  )}
                  {accounts != null && accounts.length > 0 && (
                    <>
                      {/* اگر شماره کارت وارد کرده بود */}
                      <NumericFormat
                        {...dataForm.rialAmount}
                        className="form-control text-center mb-2 mt-3 "
                        placeholder="مبلغ درخواستی"
                        name="rialAmount"
                        suffix="تومان"
                        decimalScale="0"
                        thousandSeparator=","
                        maxLength={20}
                        onValueChange={(values) => {
                          const { value } = values;
                          setValue("rialAmount", value, {
                            shouldValidate: true,
                          });
                        }}
                      />
                      {errors.rialAmount && (
                        <span className="text-danger">مبلغ را وارد نمایید</span>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            {accounts != null && accounts.length > 0 ? (
              <Button
                variant="success"
                type="submit"
                className="py-2"
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <Spinner animation="border" variant="warning" size="sm" />
                )}
                <ArrowUpward className="mr-1" />
                برداشت از کیف پول
              </Button>
            ) : (
              <Link to="/agentAccount" className="btn btn-primary py-2 px-5 ">
                <AddCircle className="mr-1" />
                افزودن شماره حساب
              </Link>
            )}

            <Button variant="danger" onClick={handleClose} className="py-2">
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
